module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.hasWorkflow) ? _c('div', [_c('workflowInstance', {
    attrs: {
      "workflowInstanceDto": _vm.workflowInstanceDto
    }
  }), _vm._v(" "), _c('workflowHistory', {
    attrs: {
      "hideSubmitUser": _vm.isClientUser || _vm.isRestrictedRole,
      "workflowInstanceStatusDtoList": _vm.workflowInstanceStatusDtoList
    }
  }), _vm._v(" "), (_vm.workflowId == 3000 && _vm.isAgency) ? _c('investigationCheckedBox', {
    attrs: {
      "investigationId": _vm.parentId
    }
  }) : _vm._e(), _vm._v(" "), _c('workflowSubmit', {
    ref: "workflowSubmit",
    attrs: {
      "fieldworkRequestErrors": _vm.fieldworkRequestErrors,
      "investigation": _vm.investigation,
      "workflowStatusDtoNextList": _vm.workflowStatusDtoNextList,
      "workflowInstanceId": _vm.workflowInstanceId
    },
    on: {
      "workflowBeforeSubmit": _vm.workflowOnBeforeSubmit,
      "workflowSubmitOnSubmitSuccess": _vm.workflowSubmitOnSubmitSuccess
    }
  }), _vm._v(" "), _c('user-assignment', {
    ref: "userAssignment",
    attrs: {
      "parentId": _vm.parentId,
      "workflowId": _vm.workflowId
    }
  })], 1) : _c('div', [_c('h4', [_vm._v("No Workflow found")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ff133e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Workflow.vue
// module id = 925
// module chunks = 1